export default __webpack_public_path__ + "static/media/calendar.add7ac90.svg";